import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { Platform } from "@ionic/angular";

/**
 * Whitelist & inject 3rd party script on a component level
 */
@Component({
  selector: "script-hack",
  templateUrl: "./scripthack.component.html",
  styleUrls: ["./scripthack.component.scss"],
})
export class ScriptHackComponent {
  isBrowser: boolean = false;
  isCordova: boolean = false;

  @Input() src: string;
  @Input() type: string;
  @Input() id: string;
  @Input() formEmbedType: string;
  @Input() browserOnly: boolean = false;

  @ViewChild("script") script: ElementRef;

  constructor(
    private platform: Platform,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  /**
   * Convert to script tag, inject, add ID for reference & disable duplicates
   */
  convertToScript() {
    if (
      this.isBrowser &&
      (!this.browserOnly || (this.browserOnly && !this.isCordova))
    ) {
      var element = this.script.nativeElement;
      var script = document.createElement("script");
      script.type = this.type ? this.type : "text/javascript";

      if (this.src) script.src = this.src;
      if (element.innerHTML) script.innerHTML = element.innerHTML;

      var parent = element.parentElement;
      if (this.formEmbedType == 'paperform') {
        if (
          ((this.id && !document.getElementById(this.id + "-rendered")) ||
            !this.id)
        ) {
          if (this.id) script.setAttribute("id", this.id + "-rendered");
          parent.parentElement.replaceChild(script, parent);
        }
      } else {
        if (this.id) script.id = this.id;
        parent.parentElement.replaceChild(script, parent);
      }
    }
  }

  ngAfterViewInit() {
    this.platform.ready().then(() => {
      this.isCordova = this.platform.is("cordova");
      this.convertToScript();
    });
  }
}
